import { createApi } from '@reduxjs/toolkit/query/react'
import {
    baseQuery,
    axiosBaseQuery,
    staggeredBaseQuery,
    staggeredBaseQueryWithBailOut,
} from './query'

const tagTypes = [
    'User',
    'Patient',
    'Collection',
    'DisabledState',
    'CollectionFiles',
    'CollectionSuggestions',
    'PatientFiles',
    'FavoriteFiles',
    'SharedFiles',
    'SharedSummary',
    'AggregateTags',
    'Tag',
]

export const api = createApi({
    baseQuery: baseQuery,
    reducerPath: 'fetchApi',
    tagTypes,
    endpoints: () => ({}),
})

export const retryApi = createApi({
    baseQuery: staggeredBaseQuery,
    reducerPath: 'retriedApi',
    endpoints: () => ({}),
})

export const retryWithBailOutApi = createApi({
    baseQuery: staggeredBaseQueryWithBailOut,
    reducerPath: 'bailoutApi',
    endpoints: () => ({}),
})

export const axiosApi = createApi({
    baseQuery: axiosBaseQuery(),
    reducerPath: 'api',
    tagTypes,
    endpoints: () => ({}),
})
